import { render, staticRenderFns } from "./DisplayCardHead.vue?vue&type=template&id=34260d24"
import script from "./DisplayCardHead.vue?vue&type=script&lang=js"
export * from "./DisplayCardHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports